module.exports = __webpack_public_path__ + "static/media/loading.43cfa8ba.gif";


//////////////////
// WEBPACK FOOTER
// ./src/frame/ui/popup/images/loading.gif
// module id = 611
// module chunks = 12